import React from 'react';

import cn from 'classnames';

type SvgSpriteProps = {
  name: string;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
  'data-testid'?: string;
} & React.SVGProps<SVGSVGElement>;

export const FlySvgSprite: React.FC<SvgSpriteProps> = ({
  name,
  size = 24,
  width = size,
  height = size,
  className = `icon icon-${name}`,
  'data-testid': testId,
  ...props
}) => (
  <svg
    className={cn('flex-shrink-0', className)}
    width={width || size}
    height={height || size}
    data-testid={testId || `svg-sprite-${name}`}
    data-size={width || size}
    {...props}
  >
    <use href={`#icon_${name}`} xlinkHref={`#icon_${name}`} />
  </svg>
);
